import {Component, Inject, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {FileInputComponent} from "ngx-material-file-input";
import {FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {ReplaySubject} from "rxjs";
import {MatSnackBar} from "@angular/material/snack-bar";
import {FormHelperService} from "../../../shared/services/form-helper.service";
import {DOCUMENT} from "@angular/common";
import {delay, first, takeUntil} from "rxjs/operators";
import {Uuid} from "../../../shared/interface/response/uuid";
import {HttpErrorResponse} from "@angular/common/http";
import {DynamicDictionaryImport} from "../../../shared/interface/dynamic-dictionary-import";
import {DynamicDictService} from "../../../shared/services/dynamic-dict.service";
import {FileBase64} from "../../../shared/components/file-drag-and-drop/file-drag-and-drop.component";

@Component({
  selector: 'app-dynamic-dictionary-import',
  templateUrl: './dynamic-dictionary-import.component.html',
  styleUrls: ['./dynamic-dictionary-import.component.scss']
})
export class DynamicDictionaryImportComponent implements OnInit, OnDestroy {

  @ViewChild('fileInput') fileInputComponent: FileInputComponent;

  dynamicDictionaryImportFormValid = false;
  dynamicDictionaryImportForm: FormGroup;
  fileControl: FormControl;
  dictControl: FormControl;

  fileMaxSize = 52428800;
  processingRequest = false;
  formErrors = {};
  dynamicDictionaryImport?: DynamicDictionaryImport;

  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  constructor(
    private fb: FormBuilder,
    private snack: MatSnackBar,
    private formHelper: FormHelperService,
    private dynamicDictionaryImportService: DynamicDictService,
    @Inject(DOCUMENT) private document: Document) {

    this.dynamicDictionaryImportForm = fb.group({
      type: this.dictControl = fb.control(''),
      fileContent: fb.control(''),
      fileName: fb.control(''),
      file: this.fileControl = fb.control('', [Validators.required]),    });

  }

  ngOnInit(): void {
    this.dynamicDictionaryImportForm.get('file').valueChanges
      .pipe(
        takeUntil(this.destroyed$)
      )
      .subscribe((file: any) => {
        if (file && this.fileControl.value && this.fileControl.value.length > 0) {

          this.fileControl.value.forEach((fileToRead: File) => {
            const reader = new FileReader();
            reader.readAsDataURL(fileToRead);
            reader.onload = () => {
              this.dynamicDictionaryImportForm.get('fileName').setValue(fileToRead.name);
              this.dynamicDictionaryImportForm.get('fileContent').setValue(/base64,(.+)/.exec(reader.result.toString())[1]);
            };
          });

        } else {
          this.dynamicDictionaryImportForm.get('fileContent').setValue('');
          this.dynamicDictionaryImportForm.get('fileName').setValue('');
        }
      });

    this.dynamicDictionaryImportForm.valueChanges
      .pipe(
        takeUntil(this.destroyed$),
        delay(0)
      )
      .subscribe(() => {
        this.dynamicDictionaryImportFormValid = this.dynamicDictionaryImportForm.valid;
      });
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  loadImport(importId: string): void {
    this.dynamicDictionaryImportService.getImport(importId)
      .pipe(delay(1000))
      .subscribe((dynamicDictionaryImport: DynamicDictionaryImport) => {
        this.dynamicDictionaryImport = dynamicDictionaryImport;

        if (dynamicDictionaryImport.progress !== 100) {
          this.loadImport(dynamicDictionaryImport.uuid);
        } else {
          this.snack.open('Import zakończony prawidłowo', '', {
            duration: 2000,
          });
        }
      });
  }

  fileSelected($event: FileBase64): void {
    if ($event === null){
      this.dynamicDictionaryImportForm.get('file').reset('');
    }
  }

  import(): void {
    if (!this.dynamicDictionaryImportForm.valid) {
      this.dynamicDictionaryImportForm.markAllAsTouched();
      this.snack.open('Wypełnij lub popraw wszystkie wymagane pola', '', {
        duration: 2000,
      });
      return;
    }

    this.processingRequest = true;
    this.formHelper.removeBackendErrorState(this.dynamicDictionaryImportForm, this.formErrors);
    this.formErrors = {};

    this.dynamicDictionaryImportService.import(this.dynamicDictionaryImportForm.value)
      .pipe(
        first()
      )
      .subscribe((response: Uuid) => {
        this.snack.open('Rozpoczynanie importowania', '', {
          duration: 2000,
        });
        this.processingRequest = false;
        this.loadImport(response.uuid);
      }, (error: HttpErrorResponse) => {
        this.processingRequest = false;

        this.snack.open('Podczas importu wystąpił błąd', error.status.toString(), {
          duration: 2000,
        });

        if (error.status === 400) {
          this.formErrors = error.error.error.list;
          this.formHelper.setBackendErrorState(this.dynamicDictionaryImportForm, this.formErrors);
        }
      });
  }

  resetFileValue(): void {
    this.fileControl.setValue('');
    if (this.fileInputComponent) {
      this.fileInputComponent.clear();
    }
  }

  cancel(e): void {
    return;
  }

}
